import useUiTranslation from "./utils/useUiTranslation";
// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import Login from "./pages/Login";
import Register from "./pages/Register";
import RequestAccount from "./pages/RequestAccount";
import RequestTypeSelector from "./pages/requests/RequestTypeSelector";
import StockRequestForm from "./pages/requests/StockRequestForm";
import NonStockRequestForm from "./pages/requests/NonStockRequestForm";
import StockItemRequestForm from "./pages/requests/StockItemRequestForm";
import MedicalDeviceRequestForm from "./pages/requests/MedicalDeviceRequestForm";
import ITRequestForm from "./pages/requests/ITRequestForm";
import MaintenanceRequestForm from "./pages/requests/MaintenanceRequestForm";
import WarehouseSupplyRequestForm from "./pages/requests/WarehouseSupplyRequestForm";
import MaintenanceWarehouseSupplyRequestForm from "./pages/requests/MaintenanceWarehouseSupplyRequestForm";
import MedicationRequestForm from "./pages/requests/MedicationRequestForm";
import ProcurementLogbookRequestForm from "./pages/requests/ProcurementLogbookRequestForm";
import PrintServiceRequestsPage from "./pages/PrintServiceRequestsPage";
import SupplyItemsPage from "./pages/requests/SupplyItemsPage";
import WarehouseSupplyRequestsPage from "./pages/WarehouseSupplyRequestsPage";
import CustodyIssueForm from "./pages/custody/CustodyIssueForm";
import CustodyApprovals from "./pages/custody/CustodyApprovals";
import CustodyIssuedList from "./pages/custody/CustodyIssuedList";
import ItemRecallsPage from "./pages/ItemRecallsPage";

import ApprovalsPanel from "./pages/ApprovalsPanel";
import OpenRequestsPage from "./pages/OpenRequestsPage";
import MyMaintenanceRequests from "./pages/MyMaintenanceRequests";
import ApprovalHistory from "./pages/ApprovalHistory";

import AllRequestsPage from "./pages/AllRequestsPage";
import AssignedRequestsPage from "./pages/AssignedRequestsPage";
import AdminTools from "./pages/AdminTools";
import OrganizationHierarchy from "./pages/OrganizationHierarchy";
import ApprovalDelegationsPage from "./pages/ApprovalDelegationsPage";
import ApprovalPoliciesPage from "./pages/ApprovalPoliciesPage";
import Management from "./pages/Management";
import ChangePassword from "./pages/ChangePassword";
import IncompleteRequestsPage from "./pages/IncompleteRequestsPage";
import IncompleteMedicalRequestsPage from "./pages/IncompleteMedicalRequestsPage";
import IncompleteOperationalRequestsPage from "./pages/IncompleteOperationalRequestsPage";
import Dashboard from "./pages/Dashboard";
import CompletedAssignedRequestsPage from "./pages/CompletedAssignedRequestsPage";
import ClosedRequestsPage from "./pages/ClosedRequestsPage";
import ProcurementPlansPage from "./pages/ProcurementPlansPage";
import RequestSubmittedPage from "./pages/requests/RequestSubmittedPage";
import WarehouseSupplyTemplatesPage from "./pages/WarehouseSupplyTemplatesPage";
import AuditRequestsPage from "./pages/AuditRequestsPage";
import AuditRegistryPage from "./pages/AuditRegistryPage";
import LifecycleAnalytics from "./pages/LifecycleAnalytics";
import WorkloadAnalysis from "./pages/WorkloadAnalysis";
import MonthlyDispensing from "./pages/MonthlyDispensing";
import ContractsPage from "./pages/ContractsPage";
import ContractApprovalsPanel from "./pages/ContractApprovalsPanel";
import ContractApprovalStageMonitor from "./pages/ContractApprovalStageMonitor";
import ContractTemplatesPage from "./pages/ContractTemplatesPage";
import ContractClausesPage from "./pages/ContractClausesPage";
import SupplierEvaluationsPage from "./pages/SupplierEvaluationsPage";
import MyEvaluationsPage from "./pages/MyEvaluationsPage";
import EvaluationDetailsPage from "./pages/EvaluationDetailsPage";
import StockItemApprovals from "./pages/StockItemApprovals";
import WarehouseInventoryPage from "./pages/WarehouseInventoryPage";
import TechnicalInspectionsPage from "./pages/TechnicalInspectionsPage";
import LegacyTechnicalInspectionsPage from "./pages/LegacyTechnicalInspectionsPage";
import TechnicalReviewSettings from "./components/TechnicalReviewSettings";
import SurgicalConsignmentsPage from "./pages/SurgicalConsignmentsPage";
import DeviceDemosPage from "./pages/DeviceDemosPage";
import PreprocurementTechnicalReviewsPage from "./pages/PreprocurementTechnicalReviewsPage";
import ScmTechnicalInspectionsReviewPage from "./pages/ScmTechnicalInspectionsReviewPage";
import SuppliersPage from "./pages/SuppliersPage";
import SuppliersPrequalificationPage from "./pages/SuppliersPrequalificationPage";
import SupplierSrmPage from "./pages/SupplierSrmPage";
import SupplierEvaluationDashboard from "./pages/SupplierEvaluationDashboard";
import PlanningWorkbench from "./pages/PlanningWorkbench";
import HistoricalRequestsImportPage from "./pages/HistoricalRequestsImportPage";
import RfxPortalPage from "./pages/RfxPortalPage";
import SupplierPortalReadinessPage from "./pages/SupplierPortalReadinessPage";
import RiskManagementPage from "./pages/RiskManagementPage";
import ItemMasterPage from "./pages/ItemMasterPage";
import StockItemMappingWorkspace from "./pages/StockItemMappingWorkspace";
import ProcureToPayLifecyclePage from "./pages/ProcureToPayLifecyclePage";
import ProcureToPayGoodsReceiptsPage from "./pages/ProcureToPayGoodsReceiptsPage";
import ProcureToPayInvoicesPage from "./pages/ProcureToPayInvoicesPage";
import ProcureToPayPurchaseOrdersPage from "./pages/ProcureToPayPurchaseOrdersPage";
import ProcureToPayMatchingPage from "./pages/ProcureToPayMatchingPage";
import ProcureToPayAccountsPayablePage from "./pages/ProcureToPayAccountsPayablePage";
import ProcureToPayPaymentsPage from "./pages/ProcureToPayPaymentsPage";
import ProcureToPayDocumentFlowPage from "./pages/ProcureToPayDocumentFlowPage";
import ProcureToPayDashboardPage from "./pages/ProcureToPayDashboardPage";
import TaskManagementPage from "./pages/TaskManagementPage";
import BudgetControlPage from "./pages/BudgetControlPage";
import DepartmentRequestedItemsBoard from "./pages/DepartmentRequestedItemsBoard";
import RequestDetailWorkspace from "./pages/RequestDetailWorkspace";
import ProcurementEvaluationsPage from "./pages/ProcurementEvaluationsPage";
import ProcurementEvaluationDetail from "./pages/ProcurementEvaluationDetail";
import SupplyChainPerformancePage from "./pages/SupplyChainPerformancePage";
import InstitutionalPrioritiesPage from "./pages/InstitutionalPrioritiesPage";
import DepartmentPrioritiesPage from "./pages/DepartmentPrioritiesPage";
import ProcurementPriorityManagementPage from "./pages/ProcurementPriorityManagementPage";
import SparePartsRegisterPage from "./pages/SparePartsRegisterPage";
import SparePartFormPage from "./pages/SparePartFormPage";
import SparePartDetailPage from "./pages/SparePartDetailPage";
import EquipmentManagementPage from "./pages/EquipmentManagementPage";
import FixedAssetsWorkspace from "./pages/FixedAssetsWorkspace";
import AiAssistantPage from "./pages/AiAssistantPage";

import { AuthProvider, useAuth } from "./hooks/useAuth";
import {
  AccessControlProvider,
  useAccessControl,
} from "./hooks/useAccessControl";
import { NotificationProvider } from "./components/ui/NotificationProvider";
import {
  hasAnyPermission,
  hasAllPermissions,
  hasPermission,
} from "./utils/permissions";
import Navbar from "./components/Navbar";
import AppExperience from "./components/layout/AppExperience";
import DocumentPrintBranding from "./components/DocumentPrintBranding";
import { featureRegistry } from "./config/featureRegistry";
import { EVALUATION_DETAILS_ROUTE } from "./utils/routes";

const ProtectedRoute = ({
  element,
  allowedRoles = [],
  requiredPermissions = [],
  requireAllPermissions = false,
  resourceKey,
  routeKey,
}) => {
  const uiText = useUiTranslation();
  const { isAuthenticated, isLoading, user } = useAuth();
  const { resolvePermissions } = useAccessControl();
  const location = useLocation();

  if (isLoading) {
    return <div className="p-6 text-center text-gray-600">{uiText("Loading...")}</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const registryConfig = routeKey ? featureRegistry[routeKey] ?? {} : {};
  const mergedResourceKey = resourceKey ?? registryConfig.resourceKey;
  const mergedRequiredPermissions =
    requiredPermissions.length > 0
      ? requiredPermissions
      : registryConfig.requiredPermissions ?? [];
  const mergedRequireAllPermissions =
    requireAllPermissions || registryConfig.requireAllPermissions === true;
  const mergedAllowedRoles =
    allowedRoles.length > 0 ? allowedRoles : registryConfig.allowedRoles ?? [];

  const { permissions: effectivePermissions, requireAll } = mergedResourceKey
    ? resolvePermissions(
        mergedResourceKey,
        mergedRequiredPermissions,
        mergedRequireAllPermissions,
      )
    : {
        permissions: mergedRequiredPermissions,
        requireAll: mergedRequireAllPermissions,
      };

  let hasPermissionAccess = true;
  if (effectivePermissions && effectivePermissions.length > 0) {
    hasPermissionAccess = requireAll
      ? hasAllPermissions(user, effectivePermissions)
      : hasAnyPermission(user, effectivePermissions);
  }

  let hasRoleAccess = true;
  if (mergedAllowedRoles.length > 0) {
    const normalizedRole = user?.role?.toLowerCase?.() ?? "";
    hasRoleAccess = mergedAllowedRoles.some(
      (role) => String(role).toLowerCase() === normalizedRole,
    );
  }

  if (!hasPermissionAccess && !hasRoleAccess) {
    return <Navigate to="/" replace />;
  }

  return element;
};

const FallbackRedirect = () => {
  const { isAuthenticated } = useAuth();
  return <Navigate to={isAuthenticated ? "/" : "/login"} replace />;
};

const ApprovalPoliciesRoute = () => {
  const { user } = useAuth();
  const { policyId } = useParams();
  const navigate = useNavigate();
  return (
    <ApprovalPoliciesPage
      canManage={hasPermission(user, "approval-policy.manage")}
      policyId={policyId}
      onOpenPolicy={(id) => navigate(`/admin/approval-policies/${id}`)}
      onClosePolicy={() => navigate("/admin/approval-policies")}
    />
  );
};

const AppRoutes = () => (
  <Routes>
    <Route path="/fixed-assets/*" element={<ProtectedRoute element={<FixedAssetsWorkspace />} requiredPermissions={["fixed-assets.view"]} />} />
    <Route path="/fixed-assets/register/:id" element={<ProtectedRoute element={<FixedAssetsWorkspace />} requiredPermissions={["fixed-assets.view"]} />} />
    <Route path="/spare-parts" element={<ProtectedRoute element={<SparePartsRegisterPage />} requiredPermissions={["spare-parts.view"]} />} />
    <Route path="/spare-parts/new" element={<ProtectedRoute element={<SparePartFormPage />} requiredPermissions={["spare-parts.create"]} />} />
    <Route path="/spare-parts/:id/edit" element={<ProtectedRoute element={<SparePartFormPage />} requiredPermissions={["spare-parts.edit"]} />} />
    <Route path="/spare-parts/:id" element={<ProtectedRoute element={<SparePartDetailPage />} requiredPermissions={["spare-parts.view"]} />} />
    <Route path="/equipment" element={<ProtectedRoute element={<EquipmentManagementPage />} requiredPermissions={["equipment.view"]} />} />
    <Route path="/spare-parts-equipment" element={<Navigate to="/equipment" replace />} />
    {/* ✅ Public Routes */}
    <Route path="/login" element={<Login />} />
    <Route path="/request-account" element={<RequestAccount />} />
    <Route path="/register" element={<Register />} />

    {/* ✅ General Protected Routes */}
    <Route
      path="/ai-assistant"
      element={<ProtectedRoute element={<AiAssistantPage />} requiredPermissions={["ai-intelligence.use"]} />}
    />
    <Route
      path="/"
      element={<ProtectedRoute element={<RequestTypeSelector />} />}
    />
    <Route
      path="/requests/stock"
      element={<ProtectedRoute element={<StockRequestForm />} />}
    />
    <Route
      path="/requests/stock-item"
      element={
        <ProtectedRoute
          element={<StockItemRequestForm />}
          resourceKey="feature.stockItemRequests"
        />
      }
    />
    <Route
      path="/supplier-prequalification"
      element={
        <ProtectedRoute
          element={<SuppliersPrequalificationPage />}
          resourceKey="feature.suppliers"
        />
      }
    />
    <Route
      path="/requests/warehouse-supply"
      element={<ProtectedRoute element={<WarehouseSupplyRequestForm />} />}
    />
    <Route
      path="/requests/procurement-logbook"
      element={<ProtectedRoute element={<ProcurementLogbookRequestForm />} />}
    />
    <Route
      path="/requests/printing-logbook"
      element={<ProtectedRoute element={<ProcurementLogbookRequestForm />} />}
    />
    <Route
      path="/print-service-requests"
      element={<ProtectedRoute element={<PrintServiceRequestsPage />} />}
    />
    <Route
      path="/requests/historical"
      element={
        <ProtectedRoute
          element={<HistoricalRequestsImportPage />}
          resourceKey="feature.historicalRequests"
          requiredPermissions={["requests.manage"]}
          allowedRoles={["admin", "scm"]}
        />
      }
    />
    <Route
      path="/item-recalls"
      element={
        <ProtectedRoute
          element={<ItemRecallsPage />}
          resourceKey="feature.itemRecalls"
        />
      }
    />
    <Route
      path="/audit-registry"
      element={
        <ProtectedRoute
          element={<AuditRegistryPage />}
          resourceKey="feature.auditRequests"
          requiredPermissions={["requests.view-audit"]}
        />
      }
    />
    <Route
      path="/requests/maintenance-warehouse-supply"
      element={
        <ProtectedRoute
          element={<MaintenanceWarehouseSupplyRequestForm />}
          resourceKey="feature.maintenanceWarehouseSupply"
        />
      }
    />
    <Route
      path="/custody/issue"
      element={
        <ProtectedRoute
          element={<CustodyIssueForm />}
          resourceKey="feature.custody"
        />
      }
    />
    <Route
      path="/warehouse-inventory"
      element={
        <ProtectedRoute
          element={<WarehouseInventoryPage />}
          resourceKey="feature.warehouseInventory"
        />
      }
    />
    <Route path="/item-master/stock-mappings" element={<ProtectedRoute element={<StockItemMappingWorkspace />} requiredPermissions={["item-master.stock-map"]} />} />
    <Route
      path="/item-master"
      element={
        <ProtectedRoute
          element={<ItemMasterPage />}
          resourceKey="feature.itemMaster"
          requiredPermissions={["item-master.view"]}
        />
      }
    />
    <Route
      path="/budget-control"
      element={
        <ProtectedRoute
          element={<BudgetControlPage />}
          requiredPermissions={["procure-to-pay.lifecycle.view"]}
        />
      }
    />

    <Route
      path="/requests/:requestId"
      element={<ProtectedRoute element={<RequestDetailWorkspace />} />}
    />
    <Route
      path="/requests/:requestId/procure-to-pay"
      element={
        <ProtectedRoute
          element={<ProcureToPayLifecyclePage />}
          requiredPermissions={["procure-to-pay.lifecycle.view"]}
          allowedRoles={["scm", "admin", "finance", "financeapprover", "warehousekeeper", "warehousemanager", "procurementspecialist"]}
        />
      }
    />


    <Route
      path="/tasks"
      element={<ProtectedRoute element={<TaskManagementPage />} />}
    />
    <Route
      path="/procure-to-pay/lifecycle"
      element={
        <ProtectedRoute
          element={<ProcureToPayLifecyclePage />}
          requiredPermissions={["procure-to-pay.lifecycle.view"]}
          allowedRoles={["scm", "admin", "finance", "financeapprover", "warehousekeeper", "warehousemanager", "procurementspecialist"]}
        />
      }
    />

    <Route
      path="/procure-to-pay"
      element={
        <ProtectedRoute
          element={<ProcureToPayDashboardPage />}
          requiredPermissions={["procure-to-pay.lifecycle.view"]}
          allowedRoles={["scm", "admin", "finance", "financeapprover", "warehousekeeper", "warehousemanager", "procurementspecialist"]}
        />
      }
    />
    <Route path="/procurement-priorities" element={<ProtectedRoute element={<InstitutionalPrioritiesPage />} />} />
    <Route path="/procurement-priorities/department" element={<ProtectedRoute element={<DepartmentPrioritiesPage />} requiredPermissions={["procurement-priority.rank-department"]} />} />
    <Route path="/procurement-priorities/manage" element={<ProtectedRoute element={<ProcurementPriorityManagementPage />} requiredPermissions={["procurement-priority.manage"]} />} />
    <Route
      path="/supply-chain-performance"
      element={
        <ProtectedRoute
          element={<SupplyChainPerformancePage />}
          requiredPermissions={["procurement-performance.view"]}
        />
      }
    />
    <Route
      path="/procure-to-pay/receipts"
      element={
        <ProtectedRoute
          element={<ProcureToPayGoodsReceiptsPage />}
          resourceKey="feature.procureToPayReceipts"
          requiredPermissions={["procure-to-pay.receipts.manage"]}
          allowedRoles={["scm", "admin", "warehousekeeper", "warehousemanager"]}
        />
      }
    />
    <Route
      path="/procure-to-pay/invoices"
      element={
        <ProtectedRoute
          element={<ProcureToPayInvoicesPage />}
          resourceKey="feature.procureToPayInvoices"
          requiredPermissions={["procure-to-pay.invoices.manage"]}
          allowedRoles={["scm", "admin", "procurementspecialist"]}
        />
      }
    />

    <Route
      path="/procure-to-pay/purchase-orders"
      element={
        <ProtectedRoute
          element={<ProcureToPayPurchaseOrdersPage />}
          requiredPermissions={["procure-to-pay.purchase-orders.manage"]}
          allowedRoles={["scm", "admin", "procurementspecialist"]}
        />
      }
    />
    <Route
      path="/procure-to-pay/matching"
      element={
        <ProtectedRoute
          element={<ProcureToPayMatchingPage />}
          requiredPermissions={["procure-to-pay.match.manage"]}
          allowedRoles={["scm", "admin", "finance", "financeapprover", "procurementspecialist"]}
        />
      }
    />
    <Route
      path="/procure-to-pay/accounts-payable"
      element={
        <ProtectedRoute
          element={<ProcureToPayAccountsPayablePage />}
          requiredPermissions={["finance.verify"]}
          allowedRoles={["finance", "financeapprover", "admin"]}
        />
      }
    />
    <Route
      path="/procure-to-pay/payments"
      element={
        <ProtectedRoute
          element={<ProcureToPayPaymentsPage />}
          requiredPermissions={["finance.payment.manage"]}
          allowedRoles={["finance", "financeapprover", "admin"]}
        />
      }
    />
    <Route
      path="/procure-to-pay/document-flow"
      element={
        <ProtectedRoute
          element={<ProcureToPayDocumentFlowPage />}
          requiredPermissions={["procure-to-pay.lifecycle.view"]}
          allowedRoles={["scm", "admin", "finance", "financeapprover", "warehousekeeper", "warehousemanager", "procurementspecialist"]}
        />
      }
    />

    <Route
      path="/requests/:requestId/procure-to-pay/purchase-orders"
      element={
        <ProtectedRoute
          element={<ProcureToPayPurchaseOrdersPage />}
          requiredPermissions={["procure-to-pay.purchase-orders.manage"]}
          allowedRoles={["scm", "admin", "procurementspecialist"]}
        />
      }
    />
    <Route
      path="/requests/:requestId/procure-to-pay/matching"
      element={
        <ProtectedRoute
          element={<ProcureToPayMatchingPage />}
          requiredPermissions={["procure-to-pay.match.manage"]}
          allowedRoles={["scm", "admin", "finance", "financeapprover", "procurementspecialist"]}
        />
      }
    />
    <Route
      path="/requests/:requestId/procure-to-pay/accounts-payable"
      element={
        <ProtectedRoute
          element={<ProcureToPayAccountsPayablePage />}
          requiredPermissions={["finance.verify"]}
          allowedRoles={["finance", "financeapprover", "admin"]}
        />
      }
    />
    <Route
      path="/requests/:requestId/procure-to-pay/payments"
      element={
        <ProtectedRoute
          element={<ProcureToPayPaymentsPage />}
          requiredPermissions={["finance.payment.manage"]}
          allowedRoles={["finance", "financeapprover", "admin"]}
        />
      }
    />
    <Route
      path="/requests/:requestId/procure-to-pay/document-flow"
      element={
        <ProtectedRoute
          element={<ProcureToPayDocumentFlowPage />}
          requiredPermissions={["procure-to-pay.lifecycle.view"]}
          allowedRoles={["scm", "admin", "finance", "financeapprover", "warehousekeeper", "warehousemanager", "procurementspecialist"]}
        />
      }
    />
    <Route
      path="/requests/:requestId/procure-to-pay/receipts"
      element={
        <ProtectedRoute
          element={<ProcureToPayGoodsReceiptsPage />}
          resourceKey="feature.procureToPayReceipts"
          requiredPermissions={["procure-to-pay.receipts.manage"]}
          allowedRoles={["scm", "admin", "warehousekeeper", "warehousemanager"]}
        />
      }
    />
    <Route
      path="/requests/:requestId/procure-to-pay/invoices"
      element={
        <ProtectedRoute
          element={<ProcureToPayInvoicesPage />}
          resourceKey="feature.procureToPayInvoices"
          requiredPermissions={["procure-to-pay.invoices.manage"]}
          allowedRoles={["scm", "admin", "procurementspecialist"]}
        />
      }
    />
    <Route
      path="/technical-inspections"
      element={
        <ProtectedRoute
          element={<TechnicalInspectionsPage />}
        />
      }
    />
    <Route path="/technical-inspections/legacy" element={<ProtectedRoute element={<LegacyTechnicalInspectionsPage />} resourceKey="feature.technicalInspections" />} />
    <Route path="/technical-inspections/settings" element={<ProtectedRoute element={<main className="mx-auto max-w-5xl p-6"><TechnicalReviewSettings /></main>} />} />
    <Route path="/surgical-consignments" element={<ProtectedRoute element={<SurgicalConsignmentsPage />} />} />
    <Route
      path="/device-demos"
      element={<ProtectedRoute element={<DeviceDemosPage />} />}
    />
    <Route
      path="/technical-inspections/pre-procurement"
      element={<ProtectedRoute element={<PreprocurementTechnicalReviewsPage />} />}
    />
    <Route
      path="/technical-inspections/review"
      element={
        <ProtectedRoute
          element={<ScmTechnicalInspectionsReviewPage />}
          allowedRoles={["SCM", "scm", "admin"]}
          resourceKey="feature.technicalInspections"
        />
      }
    />
    <Route
      path="/custody/issued"
      element={
        <ProtectedRoute
          element={<CustodyIssuedList />}
          resourceKey="feature.custody"
        />
      }
    />
    <Route
      path="/custody/approvals"
      element={<ProtectedRoute element={<CustodyApprovals />} />}
    />
    <Route
      path="/requests/non-stock"
      element={<ProtectedRoute element={<NonStockRequestForm />} />}
    />
    <Route
      path="/requests/it-items"
      element={<ProtectedRoute element={<ITRequestForm />} />}
    />
    <Route
      path="/requests/medical-device"
      element={<ProtectedRoute element={<MedicalDeviceRequestForm />} />}
    />
    <Route
      path="/requests/medication"
      element={
        <ProtectedRoute
          element={<MedicationRequestForm />}
          allowedRoles={["requester", "Requester", "HOD", "CMO", "SCM"]}
        />
      }
    />
    <Route
      path="/approvals"
      element={<ProtectedRoute routeKey="approvals" element={<ApprovalsPanel />} />}
    />
    <Route
      path="/open-requests"
      element={<ProtectedRoute routeKey="openRequests" element={<OpenRequestsPage />} />}
    />
    <Route
      path="/request-submitted"
      element={<ProtectedRoute element={<RequestSubmittedPage />} />}
    />
    <Route
      path="/approval-history"
      element={<ProtectedRoute routeKey="approvalHistory" element={<ApprovalHistory />} />}
    />

    {/* ✅ Maintenance Routes */}
    <Route
      path="/requests/maintenance"
      element={
        <ProtectedRoute
          element={<MaintenanceRequestForm />}
          allowedRoles={["technician", "SCM", "admin"]}
        />
      }
    />
    <Route
      path="/my-maintenance-requests"
      element={
        <ProtectedRoute
          element={<MyMaintenanceRequests />}
          allowedRoles={["technician", "SCM", "admin"]}
          requiredPermissions={["maintenance-requests.view-all"]}
        />
      }
    />
    <Route
      path="/approvals/maintenance"
      element={
        <ProtectedRoute element={<Navigate to="/approvals" replace />} />
      }
    />

    <Route
      path="/warehouse-supply-templates"
      element={
        <ProtectedRoute
          element={<WarehouseSupplyTemplatesPage />}
          resourceKey="feature.warehouseTemplates"
        />
      }
    />
    <Route
      path="/warehouse-supply-requests"
      element={
        <ProtectedRoute
          element={<WarehouseSupplyRequestsPage />}
          resourceKey="feature.warehouseRequests"
        />
      }
    />

    {/* ✅ Admin / SCM Routes */}
    <Route path="/admin/approval-delegations" element={<ProtectedRoute element={<ApprovalDelegationsPage />} requiredPermissions={["approval-delegation.view"]} />} />
    <Route path="/admin/organization" element={<ProtectedRoute element={<OrganizationHierarchy />} />} />
    <Route
      path="/admin/approval-policies"
      element={
        <ProtectedRoute
          routeKey="approvalPolicies"
          element={<ApprovalPoliciesRoute />}
        />
      }
    />
    <Route
      path="/admin/approval-policies/:policyId"
      element={
        <ProtectedRoute
          routeKey="approvalPolicies"
          element={<ApprovalPoliciesRoute />}
        />
      }
    />
    <Route
      path="/admin-tools"
      element={
        <ProtectedRoute
          element={<AdminTools />}
          resourceKey="feature.adminTools"
        />
      }
    />
    <Route
      path="/management"
      element={
        <ProtectedRoute
          element={<Management />}
          resourceKey="feature.management"
        />
      }
    />
    <Route
      path="/all-requests"
      element={
        <ProtectedRoute
          element={<AllRequestsPage />}
          resourceKey="feature.allRequests"
        />
      }
    />
    <Route
      path="/incomplete"
      element={
        <ProtectedRoute
          element={<IncompleteRequestsPage />}
          resourceKey="feature.incompleteRequests"
        />
      }
    />
    <Route
      path="/procurement-plans"
      element={
        <ProtectedRoute
          element={<ProcurementPlansPage />}
          requiredPermissions={["planning.view", "planning.manage"]}
          resourceKey="feature.procurementPlanning"
        />
      }
    />
    <Route
      path="/department-requested-items"
      element={
        <ProtectedRoute
          element={<DepartmentRequestedItemsBoard />}
          allowedRoles={["scm", "admin", "procurementsupervisor"]}
        />
      }
    />
    <Route
      path="/procurement-evaluations"
      element={
        <ProtectedRoute
          element={<ProcurementEvaluationsPage />}
          requiredPermissions={["evaluations.manage"]}
        />
      }
    />
    <Route
      path="/procurement-evaluations/:id"
      element={
        <ProtectedRoute
          element={<ProcurementEvaluationDetail />}
          requiredPermissions={["evaluations.manage"]}
        />
      }
    />

    <Route
      path="/stock-item-approvals"
      element={
        <ProtectedRoute
          element={<StockItemApprovals />}
          resourceKey="feature.stockItemApprovals"
        />
      }
    />
    <Route
      path="/contracts"
      element={
        <ProtectedRoute
          element={<ContractsPage />}
          resourceKey="feature.contracts"
        />
      }
    />
    <Route
      path="/contracts/new"
      element={
        <ProtectedRoute
          element={<ContractsPage />}
          resourceKey="feature.contracts"
        />
      }
    />
    <Route
      path="/contracts/:contractId/edit"
      element={
        <ProtectedRoute
          element={<ContractsPage />}
          resourceKey="feature.contracts"
        />
      }
    />
    <Route
      path="/contracts/approvals"
      element={
        <ProtectedRoute
          element={<ContractApprovalsPanel />}
          resourceKey="feature.contracts"
        />
      }
    />
    <Route
      path="/contracts/approval-stage-monitor"
      element={
        <ProtectedRoute
          element={<ContractApprovalStageMonitor />}
          allowedRoles={["scm"]}
        />
      }
    />
    <Route
      path="/contract-templates"
      element={<ProtectedRoute element={<ContractTemplatesPage />} resourceKey="feature.contracts" />}
    />
    <Route
      path="/contract-clauses"
      element={<ProtectedRoute element={<ContractClausesPage />} resourceKey="feature.contracts" />}
    />
    <Route
      path="/suppliers"
      element={
        <ProtectedRoute
          element={<SuppliersPage />}
          resourceKey="feature.suppliers"
        />
      }
    />
    <Route
      path="/supplier-srm"
      element={
        <ProtectedRoute
          element={<SupplierSrmPage />}
          allowedRoles={[
            "SCM",
            "admin",
            "COO",
            "Medical Devices",
            "Contract_Manager",
            "ProcurementSpecialist",
            "ProcurementManager",
          ]}
          requiredPermissions={["contracts.manage"]}
          resourceKey="feature.suppliers"
        />
      }
    />
    <Route path="/rfx-portal" element={<ProtectedRoute element={<RfxPortalPage />} requiredPermissions={["rfx.manage"]} />} />
    <Route path="/supplier-portal-readiness" element={<ProtectedRoute element={<SupplierPortalReadinessPage />} />} />
    <Route
      path="/supplier-evaluations"
      element={
        <ProtectedRoute
          element={<SupplierEvaluationsPage />}
          allowedRoles={[
            "admin",
            "SCM",
            "Contract_Manager",
            "ProcurementSpecialist",
            "ProcurementManager",
          ]}
          requiredPermissions={["evaluations.manage"]}
          resourceKey="feature.supplierEvaluations"
        />
      }
    />
    <Route
      path="/supplier-dashboard"
      element={
        <ProtectedRoute
          element={<SupplierEvaluationDashboard />}
          allowedRoles={[
            "admin",
            "SCM",
            "Contract_Manager",
            "ProcurementSpecialist",
            "ProcurementManager",
          ]}
          requiredPermissions={["evaluations.manage"]}
          resourceKey="feature.supplierEvaluations"
        />
      }
    />
    <Route
      path="/risk-management"
      element={
        <ProtectedRoute
          element={<RiskManagementPage />}
          requiredPermissions={["risks.view", "risks.manage"]}
          resourceKey="feature.riskManagement"
        />
      }
    />

    {/* ✅ Procurement-Specific Routes */}
    <Route
      path="/assigned-requests"
      element={
        <ProtectedRoute
          element={<AssignedRequestsPage />}
          resourceKey="feature.procurementQueues"
        />
      }
    />

    {/* ✅ Approver Views */}
    <Route
      path="/incomplete/medical"
      element={
        <ProtectedRoute
          element={<IncompleteMedicalRequestsPage />}
          resourceKey="feature.incompleteMedical"
        />
      }
    />
    <Route
      path="/incomplete/operational"
      element={
        <ProtectedRoute
          element={<IncompleteOperationalRequestsPage />}
          resourceKey="feature.incompleteOperational"
        />
      }
    />

    <Route
      path="/completed-assigned"
      element={
        <ProtectedRoute
          element={<CompletedAssignedRequestsPage />}
          resourceKey="feature.procurementQueues"
        />
      }
    />
    <Route
      path="/closed-requests"
      element={<ProtectedRoute element={<ClosedRequestsPage />} />}
    />
    <Route
      path="/audit-requests"
      element={
        <ProtectedRoute
          element={<AuditRequestsPage />}
          resourceKey="feature.auditRequests"
        />
      }
    />
    <Route
      path="/warehouse-supply/:id"
      element={
        <ProtectedRoute
          element={<SupplyItemsPage />}
          resourceKey="feature.warehouseDetail"
        />
      }
    />
    <Route
      path="/dashboard"
      element={
        <ProtectedRoute
          element={<Dashboard />}
          resourceKey="feature.dashboard"
        />
      }
    />
    <Route
      path="/analytics"
      element={
        <ProtectedRoute
          element={<LifecycleAnalytics />}
          resourceKey="feature.analytics"
        />
      }
    />
    <Route
      path="/workload"
      element={
        <ProtectedRoute
          element={<WorkloadAnalysis />}
          resourceKey="feature.analytics"
        />
      }
    />
    <Route
      path="/dispensing"
      element={
        <ProtectedRoute
          element={<MonthlyDispensing />}
          resourceKey="feature.dispensing"
        />
      }
    />
    <Route
      path="/planning"
      element={
        <ProtectedRoute
          element={<PlanningWorkbench />}
          requiredPermissions={["planning.view", "planning.manage", "replenishment.manage"]}
          resourceKey="feature.demandPlanning"
        />
      }
    />
    <Route
      path="/change-password"
      element={<ProtectedRoute element={<ChangePassword />} />}
    />
    <Route
      path="/my-evaluations"
      element={<ProtectedRoute element={<MyEvaluationsPage />} />}
    />
    <Route
      path={EVALUATION_DETAILS_ROUTE}
      element={<ProtectedRoute element={<EvaluationDetailsPage />} />}
    />

    {/* 🚨 Catch-All Fallback */}
    <Route path="*" element={<FallbackRedirect />} />
  </Routes>
);

const AppShell = ({ children }) => {
  const { pathname } = useLocation();
  const isAuthPage = ["/login", "/register", "/request-account"].includes(
    pathname,
  );

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      {!isAuthPage ? <Navbar /> : null}
      <main
        id="main-content"
        className={isAuthPage ? "app-main app-main--auth" : "app-main"}
        tabIndex="-1"
      >
        {children}
      </main>
      <AppExperience />
    </div>
  );
};

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <NotificationProvider>
          <AccessControlProvider>
            <DocumentPrintBranding />
            <AppShell>
              <AppRoutes />
            </AppShell>
          </AccessControlProvider>
        </NotificationProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
